import React from "react";
import { Grid, Typography, Box } from "@mui/material";
// import { Grid, Typography } from "@material-ui/core";
import { InputField, DatePickerField } from "../../FormFields";

export default function EducationBackground(props) {
  const {
    formField: {
      nameOfTheBachelorDegree,
      graduatedFromUniversityInstitute,
      countryOfTheBachelorUniversityInstitute,
      dateOfBachelorDegreeGraduation,
      nameOfMasterDegree,
      graduatedMasterFromUniversityInstitute,
      countryOfTheMasterUniversityInstitute
    }
  } = props;

  return (
    <>
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Educational Background
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <InputField
            name={nameOfTheBachelorDegree.name}
            label={nameOfTheBachelorDegree.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={graduatedFromUniversityInstitute.name}
            label={graduatedFromUniversityInstitute.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={countryOfTheBachelorUniversityInstitute.name}
            label={countryOfTheBachelorUniversityInstitute.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DatePickerField
            name={dateOfBachelorDegreeGraduation.name}
            label={dateOfBachelorDegreeGraduation.label}
            inputFormat="dd/MM/yyyy"
            minDate={new Date("1950/12/31")}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={nameOfMasterDegree.name}
            label={nameOfMasterDegree.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={graduatedMasterFromUniversityInstitute.name}
            label={graduatedMasterFromUniversityInstitute.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={countryOfTheMasterUniversityInstitute.name}
            label={countryOfTheMasterUniversityInstitute.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
      </Grid>
    </>
  );
}
